<template><div>
  <div class="screen-loading" v-if="!project">
    Loading...
  </div>
  <div class="view project" v-if="project">

    <div class="project-header" :style="header_css">
      <div class="pretitle" v-if="client">
        <div class="textlink" @click="goto('/client/'+client['.key'])">{{client.name}}</div> &nbsp; &mdash; &nbsp; 
        Opgave
      </div>
      <div class="title">{{project.name}}</div>
    </div>

    <div class="filterbtns">
      <filterbtn :active="showing=='home'" @click.native="setShowing('home')">Overblik</filterbtn>
      <filterbtn :active="showing=='comments'" @click.native="setShowing('comments')">{{getCommentsCount('project',project['.key'])}} kommentarer</filterbtn>
      <filterbtn :active="showing=='spec'" @click.native="setShowing('spec')">Specifikation</filterbtn>
      <filterbtn :active="showing=='kanban'" v-if="show_beta_content||is_user('wp')" @click.native="setShowing('kanban')">Opgaver</filterbtn>
      <filterbtn :active="showing=='timelogs'" @click.native="setShowing('timelogs')">Tidstracking</filterbtn>
      <filterbtn :active="showing=='economy'" v-if="economy_access" @click.native="setShowing('economy')">Økonomiposter</filterbtn>
      <filterbtn :active="showing=='timeline'" v-if="show_beta_content" @click.native="setShowing('timeline')">Timeline</filterbtn>
      <filterbtn :active="showing=='settings'" @click.native="setShowing('settings')">Indstillinger</filterbtn>
      <filterbtn :active="showing=='details'" @click.native="setShowing('details')">Detaljer</filterbtn>
    </div>


    <template v-if="showing=='home'" :label="'Project home'">

      <masonry>

        <div class="masonry-grid-item w1 h1">
          <div class="snackbox">
            <div class="t">Status</div>
            <div class="m">
				      <svgicon icon="ionicons/ios-checkmark-outline"></svgicon>				
			      </div>
            <div class="b">{{getProjectDonePct(project)}}%</div>
          </div>
        </div>       

        <div class="masonry-grid-item w2 h1">
          <div class="snackbox">
            <div class="m up">
              {{project_budgetted_hours | decimals(0)}} timer
            </div>
            <div class="b">Estimeret</div>
          </div>
        </div>

		    <div class="masonry-grid-item w2 h1" v-if="false">
          <div class="snackbox clickable" @click="goto('/timelogs/any/any/'+ project['.key'] +'/any/any')">
            <div class="t">Tid booket</div>
            <div class="m">
      				<svgicon icon="ionicons/ios-calendar-outline"></svgicon>			
            </div>
            <div class="b">{{hoursBooked}} timer</div>
          </div>
        </div>

		    <div class="masonry-grid-item w1 h1">
          <div class="snackbox clickable" @click="goto('/timelogs/any/any/'+ project['.key'] +'/any/any')">
            <div class="t">Tid tracket</div>
            <div class="m">
				      {{project_budgetted_hours_spent_pct | decimals(0) }}%
            </div>
			      <div class="b">{{project_timelogs_total_hours | decimals(0) }} timer</div>
          </div>
        </div>
        
        <div class="masonry-grid-item w1 h1">
          <div class="snackbox clickable" @click="openTimeloggerBasic({project_key:project['.key']})">
            <div class="m up">
              <svgicon icon="ionicons/ios-play-outline"></svgicon>
            </div>
            <div class="b">Log arbejdstid</div>
          </div>
        </div>

        <div class="masonry-grid-item w1 h1" v-if="project.gitRepoUrl">
          <div class="snackbox clickable" @click="openURLNewWindow(project.gitRepoUrl)">
            <div class="m up"><svgicon icon="fontawesome/git"></svgicon></div>
            <div class="b">Git repo</div>
          </div>
        </div>

        <div class="masonry-grid-item w1 h1" v-if="project.trelloUrl">
          <div class="snackbox clickable" @click="openURLNewWindow(project.trelloUrl)">
            <div class="m up"><svgicon icon="fontawesome/trello"></svgicon></div>
            <div class="b">Trello board</div>
          </div>
        </div>

        <div class="masonry-grid-item w1 h1" v-if="project.timelineUrl">
          <div class="snackbox clickable" @click="openURLNewWindow(project.timelineUrl)">
            <div class="t up">Tidsplan</div>
            <div class="m d"><svgicon icon="ionicons/android-options"></svgicon></div>
          </div>
        </div>

        <div class="masonry-grid-item w2 h1">
          <div class="snackbox clickable" @click="showing = 'spec'">
            <div class="m up">
				      <svgicon icon="ionicons/ios-list-outline"></svgicon>
			      </div>
            <div class="b">
              <template v-if="!spec && !project.specsheetUrl">
                Opgavespecifikation mangler!
              </template>
              <template v-else>
                Opgavespecifikation/tilbud
              </template>
			      </div>
          </div>
        </div>

        <div class="masonry-grid-item w2 h1" v-if="economy_access">
          <div class="snackbox">
            <div class="m up">
				      {{ project_budget | money}} kr.
            </div>
			      <div class="b">Budget ex. moms</div>
          </div>
        </div>

        <div class="masonry-grid-item w2 h2" v-if="project.docsUrl && globals.user.admin">
          <div class="snackbox clickable" @click="openURLNewWindow(project.docsUrl)">
            <div class="m up"><svgicon icon="ionicons/android-folder-open"></svgicon></div>
            <div class="b">Google Drive</div>
          </div>
        </div>

        <div class="masonry-grid-item w2 h1" v-if="economy_access">
          <div class="snackbox">
            <div class="m up">{{get_invoiced_dkk | money }} kr.</div>            
            <div class="b">Faktureret</div>
          </div>
        </div>

        <div class="masonry-grid-item w2 h1" v-if="economy_access">
          <div class="snackbox">
            <div class="m up">{{get_invoiced_and_paid_dkk | money }} kr.</div>
            <div class="b">Betalt</div>
          </div>
        </div>
        
        <div class="masonry-grid-item w2 h1" v-if="economy_access && project.status == 'active'">
          <div class="snackbox">
            <div class="m up">{{(project_payable_amount - get_invoiced_and_paid_dkk) | money }} kr.</div>
            <div class="b">Resterende betaling</div>
          </div>
        </div>        

      </masonry>

      <br>

      <div>

        <btn color="secondary" @click.native="toggleTagAndSave('projects',project,$store.getters['users/my_initials'])">
          <template v-if="item_has_tag(project,$store.getters['users/my_initials'])">● Mine projekter</template>
          <template v-else>○ Mine projekter</template>
        </btn>

        <btn color="secondary" @click.native="toggleTagAndSave('projects',project,'fakturaklar')">
          <template v-if="item_has_tag(project,'fakturaklar')">● Faktura-klar</template>
          <template v-else>○ Faktura-klar</template>
        </btn>

      </div>


    </template>


  <template v-if="showing=='timelogs'">
    <box :label="project_timelogs_total_hours + ' timer tracket'">
      <timelogs-list v-if="project_timelogs" :timelogs="project_timelogs" />
      <p v-else>Ingen tid tracket endnu...</p>    
    </box>    
  </template>


	<template v-if="showing=='timeline'">

		<box label="New calendar">
      <full-calendar :config="calendarConfig"></full-calendar>
    </box>
    
    <timeline title="Timeline" days-back="7" days-ahead="120" :entries="[ { title:'2018-08-25 >> 2018-09-03', date_from:project.start_date, date_to:project.end_date, color:projectColor, fillpct:75 }, ]"></timeline>      

	</template>


    <box v-if="showing=='settings'" :label="'Indstillinger'">

      <div class="grid">
        <div class="col m50">

          <inputfield label="Opgavens titel">
            <input type="text" :value="project.name" @change="change('name',$event)">
          </inputfield>

          <br>

          <inputfield label="Kunde">
            <select v-model="project.client_key" @change="change('client_key',$event)">
              <option :value="client.key" v-for="(client,key,i) in clients_not_archived" :key="'tf23'+i">{{client.name}}</option>
            </select>
            <div class="select-arrow">▾</div>
          </inputfield>

          <template v-if="economy_access">
            <br>
            <inputfield :label="'Timepris (Kundens normale timepris: '+(client.hour_rate||'Udefineret')+')'">
              <input type="number" :value.number="project.hour_rate" @change="change('hour_rate',$event)">
            </inputfield>
          </template>

          <template v-if="economy_access">
            <br>
            <inputfield label="Fast pris ex. moms (Gammel, brug i stedet Opgavespecifikationen)">
              <input type="number" :value.number="project.fixed_price" @change="change('fixed_price',$event)">
            </inputfield>
          </template>

          <template v-if="economy_access">
            <br>
            <inputfield label="Estimerede timer (Gammel, brug i stedet Opgavespecifikationen)">
              <input type="number" :value.number="project.estimated_hrs" @change="change('estimated_hrs',$event)">
            </inputfield>
          </template>

          <br>

          <inputfield label="Færdig %">
            <input type="number" :value.number="project.done_pct" @change="change('done_pct',$event)">
          </inputfield>

          <br>

          <inputfield>
            <label>Noter</label>
            <textarea name="" id="" v-model="project.notes" cols="30" rows="10" @change="change('notes',$event)"></textarea>
          </inputfield>

          <br>


        </div>
        <div class="col m50">

          <inputfield label="Farve">
            <input type="text" :value="project.color" @change="change('color',$event)">
          </inputfield>

          <br>

          <inputfield label="Status">
            <select v-model="project.status" @change="change('status',$event)">
              <option :value="key" v-for="(status,key,i) in globals.projectStatuses">{{status.title}}</option>
            </select>
            <div class="select-arrow">▾</div>
          </inputfield>

          <br>

          <inputfield label="Betalingsmodel">
            <select v-model="project.payment_model" @change="change('payment_model',$event)">
              <option value="fixed_price">Fast pris</option>
              <option value="time_expense">Tidsafregnet</option>
            </select>
            <div class="select-arrow">▾</div>
          </inputfield>

          <br>

          <tags-preview v-if="false" :tags="project.tags" :itemtype="'project'" :itemkey="project.key" />

          <inputfield label="Tags">
            <input type="text" v-model="project.tags" @change="change('tags',$event)" />
          </inputfield>

          <br>
          
          <inputfield label="Startdato (dd-mm-ååååå)">
            <input type="date" :value.number="project.start_date" @change="change('start_date',$event)">
          </inputfield>

          <br>

          <inputfield label="Afslutningsdato (dd-mm-ååååå)">
            <input type="date" :value.number="project.end_date" @change="change('end_date',$event)">
          </inputfield>

          <br>

          <template v-if="economy_access">

            <inputfield label="Dokument mappe-link (Google Drive)">
              <input type="text" :value="project.docsUrl" @change="change('docsUrl',$event)">
            </inputfield>

            <br>

            <inputfield label="Tidsplan dokument-link">
              <input type="text" :value="project.timelineUrl" @change="change('timelineUrl',$event)">
            </inputfield>

            <br>

            <inputfield label="Trello board link">
              <input type="text" :value="project.trelloUrl" @change="change('trelloUrl',$event)">
            </inputfield>

            <br>

            <inputfield label="Git repo link">
              <input type="text" :value="project.gitRepoUrl" @change="change('gitRepoUrl',$event)">
            </inputfield>

          </template>

        </div>
      </div><!--.grid-->

      <br><br>

      <btn @click.native="submitChanges()">Opdatér opgave</btn>

      <br><br>

      <div class="btn color-secondary" @click="archiveProject()">Arkivér opgave</div>

    </box>


    <box v-if="showing=='economy'" :label="'Økonomi'">
      <p v-if="false">Budget: {{outputMoney(getProjectBudgetTotal(project),'b')}}</p>
      
      <economy-posts :posts="economyposts.posts" :totals="economyposts.totals" fields="invoice_no,invoice_date,invoiced,paid,amount" />    

      <br>

      <btn @click.native="createNewEconomypost()">Opret ny økonomipost</btn>    

    </box>



    <box v-if="showing=='details'" :label="'Andet'">
      
      <table class="table-a">
          
          
          <tr>
            <td>Betalingsmodel</td>
            <td>
              <template v-if="project.payment_model == 'fixed_price'">Fast pris</template>
              <template v-if="project.payment_model == 'time_expense'">Tidsafregnet</template>
              <template v-if="!project.payment_model">?</template>
            </td>           
          </tr>


          <tr>
            <td>Timepris</td>
            <td>
              {{ project_hour_rate | money(2) }} kr.
            </td>
          </tr>          
          
          <tr>
            <td>Estimerede timer</td>
            <td>{{project_budgetted_hours || '-'}} timer</td>
          </tr>          
          
          <tr>
            <td>Arbejdstimer logget</td>
            <td>{{project_timelogs_total_hours}} timer</td>
          </tr>

          <tr>
            <td>- Heraf markeret fakturérbare</td>
            <td>{{project_billable_hours}} timer</td>
          </tr>         
          
          <tr>
            <td>Budget</td>
            <td>{{ project_budget | money}} kr.</td>
          </tr>         

          <tr><td>&nbsp;</td><td>&nbsp;</td></tr>

          <tr v-if="economy_access">
            <td>Kundens betaling</td>
            <td><b>{{project_payable_amount | money(2) }} kr.</b></td>
          </tr>

          <tr v-if="economy_access">
            <td>- Faktureret</td>
            <td>{{get_invoiced_dkk | money(2) }} kr.</td>
          </tr>

          <tr v-if="economy_access">
            <td>- Betalt</td>
            <td>{{get_invoiced_and_paid_dkk | money(2) }} kr.</td>
          </tr>

          <tr v-if="economy_access">
            <td>Resterende betaling</td>
            <td>{{(project_payable_amount - get_invoiced_and_paid_dkk) | money(2) }} kr.</td>
          </tr>

          <tr><td>&nbsp;</td><td>&nbsp;</td></tr>

          <tr>
            <td>Betaling ud fra fakturérbare timer</td>
            <td>{{ project_billable_hours_amount | money(2) }} kr.</td>
          </tr>
          
          <tr>
            <td>Timepris * tidsforbrug</td>
            <td>{{ project_hour_rate * project_timelogs_total_hours | money(2) }} kr.</td>
          </tr>

          <tr>
            <td>Tid tracket ift. budget tidsramme</td>
            <td>{{ project_budgetted_hours_spent_pct }} %</td>
          </tr>

          <tr>
            <td>Realiseret timepris</td>
            <td>{{ ( project_payable_amount / project_timelogs_total_hours ) | money(2) }} kr.</td>
          </tr>
          
          <tr><td>&nbsp;</td><td>&nbsp;</td></tr>

          <tr>
            <td>Projekt oprettet</td>
            <td>{{ project.created | date('DD/MM-YYYY HH:MM') }} </td>
          </tr>
        
      </table>     

    </box>


    <template v-if="showing=='spec'">
      <specsheet v-if="spec" :localspec="spec" />
      <div class="btn" v-if="!spec" @click="createSpec()">Opret opgavespecifikation</div>
    </template>

    
    <box v-if="showing=='comments'" :label="'Kommentarer'">
      <comments :keytype="'project'" :keyis="project_key" />
    </box>


    <div v-if="showing=='kanban'">
      <kanban />
    </div>

    <div id="tasklists" v-if="showing=='_tasks'">
      <div class="tasklist" v-for="(tasklist,i) in projectTasklists" v-if="!tasklist.archived">
        <div class="tasklist-header">
          <div class="title">{{tasklist.name}}</div>
          <div class="edit-btn" @click="openTasklistPopup(tasklist)">
            <svgicon icon="ionicons/gear-b"></svgicon>
          </div>
        </div>
        <div class="tasks" v-dragula="project_tasks" bag="first-bag">
          <div class="task" v-for="(task,i) in project_tasks" :key="task['.key']" v-if="task.tasklist_key == tasklist['.key'] && !task.archived" @click="openTaskPopup(task)">
            {{task.title}}
          </div>
        </div>
        <div class="tasklist-footer">
          <div class="add-task-btn" @click="addTask(tasklist)">
            <svgicon icon="linearicons/home"></svgicon> Ny task
          </div>
        </div>
      </div>
      <div class="add-tasklist-btn" @click="addTaskList()">
        <svgicon icon="linearicons/home"></svgicon> Ny liste
      </div>
    </div>



    <box v-if="show_debug_data_boxes" label="project">
      <pre>{{project}}</pre>
    </box>  



    <div id="tasklist-overlay" v-if="activeTasklistKey">
      <div class="dimmer" @click="closeTasklistPopup()"></div>
      <div class="modal">

        <inputfield>
          <label>Name</label>
          <input type="text" v-model="activeTasklist.name" @change="updateActiveTasklist(['name'])">
        </inputfield>

        <btn @click.native="archiveTasklist()">Slet tasklist</btn>
      </div>
    </div>


    <div id="task-overlay" v-if="activeTaskKey">
      <div class="dimmer" @click="closeTaskPopup()"></div>
      <div class="modal">

        <inputfield>
          <label>Titel</label>
          <input type="text" v-model="activeTask.title" @change="updateActiveTask(['title'])">
        </inputfield>

        <inputfield>
          <label>Text</label>
          <textarea v-model="activeTask.text" @change="updateActiveTask(['text'])"></textarea>
        </inputfield>

        <inputfield>
          <label>Timetal estimat</label>
          <input type="number" min="0" max="9999" step="0.25" v-model="activeTask.hours_estimate" @change="updateActiveTask(['hours_estimate'])">
        </inputfield>

        <inputfield>
          <label>Done?</label>
          <br/>
          <input type="checkbox" :checked="activeTask.done" v-model="activeTask.done" @change="flipTaskDone(activeTask)">
        </inputfield>

        <btn @click.native="archiveTask()">Slet opgave</btn>
      </div>
    </div>


  </div>

</div></template>

<script>
import fdb from '.././firebase_config.js'
import mixins from '../mixins.js'
import helpers from '../helpers.js'
import moment from 'moment'
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Inputfield from '.././components/Inputfield'
import Avatar from '.././components/Avatar'
import Filterbtn from '.././components/Filterbtn'
import Minipctbar from '.././components/Minipctbar'
import Minidonut from '.././components/Minidonut'
import Masonry from '.././components/Masonry'
import Specsheet from '.././components/Specsheet'
import TimelogsList from '.././components/TimelogsList'

import Timeline from '.././components/Timeline'
import FullCalendar from '.././components/FullCalendar'
import Comments from '.././components/Comments'
import Kanban from '.././components/Kanban'
import EconomyPosts from '.././components/EconomyPosts'
import TagsPreview from '.././components/TagsPreview'

import './../components/generated_svg_icons/logo'
import './../components/generated_svg_icons/linearicons/briefcase'
import './../components/generated_svg_icons/ionicons/gear-b'
import './../components/generated_svg_icons/fontawesome/trello'
import './../components/generated_svg_icons/fontawesome/git'
import './../components/generated_svg_icons/ionicons/android-folder-open'
import './../components/generated_svg_icons/ionicons/ios-list-outline'
import './../components/generated_svg_icons/ionicons/android-options'
import './../components/generated_svg_icons/ionicons/ios-timer-outline'
import './../components/generated_svg_icons/ionicons/ios-checkmark-outline'
import './../components/generated_svg_icons/ionicons/ios-timer-outline'
import './../components/generated_svg_icons/ionicons/ios-calendar-outline'
import './../components/generated_svg_icons/ionicons/ios-list-outline'
import './../components/generated_svg_icons/ionicons/ios-play-outline'

export default {
  name: 'project',
  mixins: [ mixins.db, mixins.generic ],
  components: { Box, Btn, Avatar, Inputfield, Minipctbar, Minidonut, Filterbtn, Masonry, Timeline, FullCalendar, Comments, Kanban, EconomyPosts, Specsheet, TagsPreview, TimelogsList, },
  data: function () {
    return {
      globals: this.$parent.globals,
      //project: undefined,
      activeTasklistKey: undefined,
      activeTaskKey: undefined,
      showing: 'home',
      changes: {},
      colOne: ['hey','der','dig'],
      colTwo: ['ey','ho','yo'],
    }
  }, // data
  computed: {

    
    project_key(){ return this.$route.params.id },
    project(){ return this.getOne('project',this.project_key) },
    clients(){ return this.getAll('clients') },
    clients_not_archived(){ return this.clients.filter((e) => !e.archived ) },

    projectColor(){
      if( this.project.color ) return this.project.color
      //if( this.client && this.client.color ) return this.client.color
      var initials = helpers.getItemInitials(this.project)
      var color = helpers.getColorByString(initials)      
      return color

    },

    activeTask(){
      if( !this.activeTaskKey || !this.$store.state.firebase.tasks[this.activeTaskKey] ) return undefined
      var task =  this.$store.state.firebase.tasks[this.activeTaskKey]
      task['.key'] = this.activeTaskKey
      return task
    },

    activeTasklist(){
      if( !this.activeTasklistKey || !this.$store.state.firebase.tasklists[this.activeTasklistKey] ) return undefined
      var tasklist =  this.$store.state.firebase.tasklists[this.activeTasklistKey]
      tasklist['.key'] = this.activeTasklistKey
      return tasklist
    },

    project_tasks() {
      var project = this.project
      return this.tasks.filter(function(task){
        return ( task.project_key == project['.key'] )
      })
    },

    projectTasklists(){
      var tasklists = []
      var list = this.$store.state.firebase.tasklists      
      for( var tasklist_key in list ) {
        if(tasklist_key == '.key') continue // why, vuexfire?
        var tasklist = list[tasklist_key]
        tasklist['.key'] = tasklist_key
        if( tasklist.project_key != this.project['.key'] ) continue
        if( tasklist.archived ) continue
        tasklists.push(tasklist)
      }
      return tasklists
    },

	hoursBooked(){
		var bookings = this.getFilteredTimebookings({
			project_key: this.project_key
		})
		var hrs = 0
		for( var i = 0; i < bookings.length; i++ ) {
			var booking = bookings[i]
			hrs += booking.hours
		}
		return hrs
  },

    client(){ return this.$store.getters['clients/getOne'](this.project.client_key) },
    spec(){ return this.$store.getters['specs/getByProjectKey'](this.project_key) },
    
    project_billable_hours_amount(){ return this.$store.getters['projects/get_billable_hours_amount'](this.project) },
    project_budget(){ return this.$store.getters['projects/getBudget'](this.project) },
    project_budgetted_hours(){ return this.$store.getters['projects/get_budgetted_hours'](this.project) },
    
    project_timelogs(){ return this.$store.getters['timelogs/get_cached'].project[this.project_key] },
    project_timelogs_total_hours(){ return this.$store.getters['timelogs/getTotalHours'](this.project_timelogs) },

    project_budgetted_hours_spent_pct(){ return this.$store.getters['projects/get_budgetted_hours_spent_pct'](this.project,this.project_timelogs) },
    project_payable_amount(){ return this.$store.getters['projects/get_payable_amount'](this.project) },
    project_billable_hours(){ return this.$store.getters['projects/get_billable_hours'](this.project) },

    project_hour_rate(){ return this.$store.getters['projects/get_hour_rate'](this.project)  },

    hoursTrackedMultipliedByProjectRate(){
      var hour_rate = this.project_hour_rate
      var hours_tracked = this.project_timelogs_total_hours
      if( !hour_rate || !hours_tracked ) return 0
      return hour_rate * hours_tracked

    },


    calendarConfig(){
			return {
				editable: true,
				//events: this.calendarEvents,				
				//eventClick: this.calendarEventClicked,				
			}
    },

    economyposts(){ return this.$store.getters['economyposts/getFilteredAndTotals']({ project_key: this.project_key }) },
    

    get_invoiced_dkk(){ return this.$store.getters['projects/get_invoiced_dkk']( this.project ) },
    get_invoiced_and_paid_dkk(){ return this.$store.getters['projects/get_invoiced_and_paid_dkk']( this.project ) },
    is_fully_invoiced(){ return this.$store.getters['projects/is_fully_invoiced']( this.project ) },
    is_fully_invoiced_and_paid(){ return this.$store.getters['projects/is_fully_invoiced_and_paid']( this.project ) },

    header_css(){
      var color = this.projectColor
      return {
        //'background-image': 'url(https://source.unsplash.com/random)',
        backgroundColor: color,
        color: 'white',
      }
    },


  }, // computed
  methods: {

    getProjectDonePct: helpers.getProjectDonePct,
    getProjectHoursEstimate: helpers.getProjectHoursEstimate,
	  getFilteredTimebookings: helpers.getFilteredTimebookings,
    getProjectBudgetTotal: helpers.getProjectBudgetTotal,
    getProjectAcceptedSpec: helpers.getProjectAcceptedSpec,
    getSpecTotalHours: helpers.getSpecTotalHours,
		getSpecTotalBudget: helpers.getSpecTotalBudget,
    outputMoney: helpers.outputMoney,
    getColorByString: helpers.getColorByString,
    getItemInitials: helpers.getItemInitials,    
    
    onTaskDrop: function(e) {
      console.log(e)
      console.log(e.target)
    },

    change( key, e ) {
      var val = e.target.value
      this.changes[key] = val
    },

    submitChanges() {
      var id = this.$route.params.id
      var data = this.changes

      if( !this.project.client_key ) {
        eventBus.$emit('toast', {text:'OBS: Du mangler at vælge kunde...'})
        return false
      }

      fdb.ref('projects').child( id ).update(data)
      eventBus.$emit('toast', {text:'Saved'})
    },

    incrementGlobalCount() {
		  //console.log(this.$root)
		  //this.$parent.globals.count++
		  window.globals.count++
	  },
    setShowing(input){
      this.showing = input
    },
    addTaskList(){
      //var project_key = this.project['.key']
      //alert(this.project['.key'])
      fdb.ref('tasklists').push({
        name: 'Ny opgaveliste',
        project_key: this.project['.key']
      })
    },

    openTaskPopup(task){
      this.activeTaskKey = task['.key']
    },

    closeTaskPopup(){
      this.activeTaskKey = undefined
    },

    openTasklistPopup(tasklist){
      this.activeTasklistKey = tasklist['.key']
    },

    closeTasklistPopup(){
      this.activeTasklistKey = undefined
    },

    updateActiveTask(fields){
      var data = {}
      for( var i in fields ) {
        var key = fields[i]
        data[key] = this.activeTask[key]
      }
      fdb.ref('tasks').child(this.activeTaskKey).update(data)
    },

    updateActiveTasklist(fields){
      var data = {}
      for( var i in fields ) {
        var key = fields[i]
        data[key] = this.activeTasklist[key]
      }
      fdb.ref('tasklists').child(this.activeTasklistKey).update(data)
    },

    archiveTask(){
      fdb.ref('tasks').child(this.activeTaskKey).update({ archived:true })
      this.closeTaskPopup()
    },

    archiveTasklist(){
      var confirmed = confirm('Sikker? Dette vil også arkivere alle opgaver på denne liste')
      if( !confirmed ) return
      fdb.ref('tasklists').child(this.activeTasklistKey).update({ archived:true })
      this.archiveTasksBelongingToTasklist(this.activeTasklistKey)
      this.closeTasklistPopup()
    },

    archiveTasksBelongingToTasklist(tasklist_key){
      for( var i in this.tasks ) {
        var task = this.tasks[i]
        if( task.tasklist_key == tasklist_key ) {
          fdb.ref('tasks').child(task['.key']).update({ archived:true })
        }
      }

    },

    addTask(tasklist){
      fdb.ref('tasks').push({
        title: 'ny task',
        done: false,
        tasklist_key: tasklist['.key'],
        project_key: this.project['.key'],
        hours_estimate: 1
      })
    },

    flipTaskDone(task){
      var key = task['.key']
      var data = { done:task.done }
      fdb.ref('tasks').child(key).update(data)
    },

    archiveProject(){
      var confirmed = confirm('Sikker?')
      if( !confirmed ) return
      var confirmed2 = confirm('Helt sikker?')
      if( !confirmed2 ) return
      fdb.ref('projects').child(this.project['.key']).update({ archived:true })
      this.$router.replace('/client/'+this.client.key)
    },


    animationDelay(i){
      var stagger = 100
      var delay = i * stagger
      return { 'animation-delay': delay+'ms' }
    },


    createSpec(){
      
      if( !this.project.hour_rate ) {
        this.msg('Du mangler at angive timepris for projektet...')
        return
      }

      if( !this.project.payment_model ) {
        this.msg('Du mangler at angive betalingsmodel for projektet...')
        return
      }

      var entry = {
        type: 'fixed_prices',
        project_key: this.project.key,
        hour_rate: this.project.hour_rate,
        status: 'draft',
        created: moment().format('YYYY-MM-DD HH:mm:ss'),
        date: moment().format('YYYY-MM-DD HH:mm:ss'),
        taskcats: [
          { title:'Ny kategori', tasks:[], },
        ],
        notes: '',
        showLineTotals: false,
        showCatTotals: false,
      }
      if( this.project.payment_model && this.project.payment_model == 'time_expense' ) entry.type = 'estimates'
      if( this.project.payment_model  ) entry.payment_model = this.project.payment_model
      var new_entry = fdb.ref('specs').push(entry)
      var new_entry_key = new_entry.getKey()
    },
      

    gotoSpec() {

      if( !this.spec && this.project.specsheetUrl ) {
        if( globals.user.admin ) {
          this.openURLNewWindow(this.project.specsheetUrl)
        } else {
          this.toast('Beklager - du har ikke adgang til dette...')
        }
      }

      if( !this.spec ) {
        this.toast('Kravsspec mangler...')
      }
      if( this.spec ) {
        this.$router.push('/spec/' + this.spec['.key'])
      }


    },

  
    createNewEconomypost() {
      var new_economypost = {
        project_key: this.project['.key'],
        created: moment(this.now).format('YYYY-MM-DD hh:mm:SS'),
        //date_due: moment().month(this.activeMonth-1).year(this.activeYear).add(0,'months').format('YYYY-MM-DD'),
        amount_dkk_ex_vat: 0,
        invoice_date: moment(this.now,'YYYY-MM-DD').format('YYYY-MM-DD'),
        payment_due_date: moment(this.now,'YYYY-MM-DD').format('YYYY-MM-DD'),
      }
      var new_entry = fdb.ref('economyposts').push(new_economypost)
      var new_entry_key = new_entry.getKey()

      var new_economypost = this.$store.getters['economyposts/getOne'](new_entry_key)

      console.log('new_entry_key: ' + new_entry_key, new_economypost)

      eventBus.$emit('toast', {text:'Økonomipost oprettet'})     
      
      // open it
      globals.modal_economypost_edit.economypost = new_economypost
      globals.modal_economypost_edit.active = true     

    },

  }, // methods


  created(){
    //this.project = this.projects[this.$route.params.id]
    //Vue.vueDragula.options('my-bag', {
    //  direction: 'vertical'
    //})
    //Vue.vueDragula.eventBus.$on('drop', function (args) {
    //  console.log('drop: ' + args[0])
    //})

    
    if( !this.project.hour_rate ) this.toast('OBS: Der mangler angivet timepris...')
    if( !this.project.payment_model ) this.toast('OBS: Der mangler angivet betalingsmodel...')

  },

  mounted(){
    var _this = this
    
    this.$store.commit('set_context_bgcolor', this.projectColor)
    
    if( this.client.bgimg_tags ) {
      this.$store.commit('set_context_bgimg', null)    
      var url = 'https://source.unsplash.com/1200x600/?'+this.client.bgimg_tags+''    
      helpers.img_loaded(url, () => {
        setTimeout(() => {
          _this.$store.commit('set_context_bgimg', url)
        }, 300)
      })
    }

  },

  destroyed(){

    this.$store.commit('set_context_bgcolor', null)
    this.$store.commit('set_context_bgimg', null)    

  },
}
</script>



// WEBPACK FOOTER //
// Project.vue?3e615d46